var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workout-log__success-area"},[_c('img',{staticClass:"workout-log__success-area-img",attrs:{"src":_vm.$appConfig.imagesUrl + 'icons/tick-green.svg'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }